import { useEffect } from 'react';

// Replace AD_SLOT with your actual AdSense ad slot ID from your AdSense dashboard.
const AD_CLIENT = 'ca-pub-3216958122764940';
const AD_SLOT = '9764779763';

function AdBanner() {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      // AdSense not loaded (dev mode / ad blocker) — fail silently
    }
  }, []);

  return (
    <div className="Chapter-ad-wrapper">
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={AD_CLIENT}
        data-ad-slot={AD_SLOT}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}

export default AdBanner;
